var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _path19, _path20, _g3, _path21, _path22, _g4, _g5, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g6, _g7, _g8, _path34, _path35, _g9, _path36, _g10, _path37, _g11, _path38, _g12, _g13, _path39, _path40, _path41, _path42, _path43;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 919 876",
    width: 919,
    height: 876,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5481505_2808164-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #e1e2fe } \n\t\t.s1 { fill: #ecf1f7 } \n\t\t.s2 { fill: #3e479b } \n\t\t.s3 { opacity: .6;fill: #ef929c } \n\t\t.s4 { fill: #ffffff } \n\t\t.s5 { opacity: .7;fill: #ffffff } \n\t\t.s6 { opacity: .1;fill: #3e479b } \n\t\t.s7 { fill: #f7a9b4 } \n\t\t.s8 { opacity: .4;fill: #f7a9b4 } \n\t\t.s9 { fill: #599af2 } \n\t\t.s10 { opacity: .7;fill: #6d6cd4 } \n\t\t.s11 { opacity: .4;fill: #6d6cd4 } \n\t\t.s12 { opacity: .4;fill: #3e479b } \n\t\t.s13 { fill: #6161b5 } \n\t\t.s14 { opacity: .8;fill: #ffffff } \n\t\t.s15 { opacity: .6;fill: #3e479b } \n\t\t.s16 { fill: #4c65ba } \n\t\t.s17 { fill: #f28393 } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.4
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m860 701.8c-65.8 78.4-173.2 107.6-275 117.9-108.8 11-219.8 4.9-325.3-23.7-52.6-14.3-105.1-35.2-144.3-73.1-52.5-50.7-74.7-129.4-61.2-201.2 21.1-111.6 119.5-199.7 233.7-202.4 31-0.7 55.3-26.8 53.2-57.8q-0.1-1.5-0.1-2.3c-15.7-149.2 157.7-219.1 281.6-176.2 41.5 14.4 78.4 42.5 103.6 78.4 25.3 35.9 23.7 77.7 44.1 114 12.1 21.6 33.2 36.3 51.7 52.6 52.1 45.9 87.4 110.8 95.2 179.7 1.7 14.7 2.1 29.5 1.2 44.3-3.2 54.5-23.3 108.1-58.4 149.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m421.6 45.8c0 14.7-11.9 26.6-26.6 26.6-14.7 0-26.6-11.9-26.6-26.6 0-14.7 11.9-26.6 26.6-26.6 14.7 0 26.6 11.9 26.6 26.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m768 29.6c0 7.5-6.1 13.7-13.7 13.7-7.6 0-13.7-6.2-13.7-13.7 0-7.6 6.1-13.8 13.7-13.8 7.6 0 13.7 6.2 13.7 13.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m288.4 105.3c0 10.1-8.2 18.4-18.4 18.4-10.1 0-18.3-8.3-18.3-18.4 0-10.2 8.2-18.4 18.3-18.4 10.2 0 18.4 8.2 18.4 18.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m99.9 772c0 23.1-18.7 41.8-41.8 41.8-23.1 0-41.9-18.7-41.9-41.8 0-23.2 18.8-41.9 41.9-41.9 23.1 0 41.8 18.7 41.8 41.9z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.5
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m845.1 132.3c-14.5-21.7-50.3-41.7-38.4-64.9 11.9-23.2 56.6-24.1 79.8-12.2 23.3 11.9 32.5 40.5 20.5 63.7-11.9 23.2-41.5 43.6-61.9 13.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.5
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m799.9 785c17.6-9.5 35.5-35.2 52.4-24.4 16.8 10.9 14.1 45 3.2 61.8-10.8 16.8-33.3 21.7-50.1 10.8-16.8-10.9-30.1-35-5.5-48.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.5
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m115.3 73.3c-24 7.9-51.9 36-70.4 18.8-18.5-17.2-7.6-58.9 9.6-77.4 17.2-18.5 46.1-19.6 64.6-2.4 18.5 17.1 29.6 50-3.8 61z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.5
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m30 188.8c47.8-72.1 139.2-134.5 220.9-117 126.6 27.1 151.9 46.8 275.8 37.4 59.9-4.5 119.2 9.1 176.8 28 61.1 20 118.9 56.3 153.4 110.6 9.5 14.9 17.2 31.4 18.7 49 2.2 26.4-9.9 51.8-12.9 78.2-4.3 37.8 9.6 74.4 17.8 110.7 8 35.3 6.7 67.7-4 102.3-13.4 43.3-43.5 83.6-86.6 108.5-67.1 38.6-155.9 35-229.3 9.6-30.7-10.6-60.5-24.9-93.5-28.2-39.6-4.1-76.6 8.7-114.5 18.4-39.3 10.1-79.7 17.6-120.3 18.1-45 0.6-90.9-8-130.1-31.2-48.2-28.5-87.1-81.2-80.9-141.1 3-29.2 4.5-56.5 10.5-85.9 9.8-48.4-18.5-83.3-27.8-128.6-7.9-38.6-3.4-79.9 13.1-115.7 3.7-8 8-15.7 12.9-23.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.8
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m105.7 250.3c9.4-30.4 55.4-74.5 83.6-89.3 130.3-68.4 272-70 413.7-23.3 0.1 0 139.8 45.9 139.8 45.9 65.6 21.6 109.2 84.5 105.1 153.5q-0.1 0.7-0.1 1.4c-2.6 40-16 79.2-38 112.1-19.9 29.8-47.5 63.1-54.4 99.6-5.5 29.1 6.4 58.5 7.8 88.2 3.2 64-44.3 120.7-98.8 143.8-51 21.8-110.9 19.5-160.8-4.5-27-13-51.6-32.5-69.6-57.4-15.9-22-25.3-55.3-56.1-58.9-55.8-6.6-114.4 17.4-169.9 21.8-37.3 2.9-77-2.1-107.3-25-19.6-14.9-34-36.3-43.9-59.4-20.4-47.9-21.2-103-4.4-152.2 11.4-33.3 39.3-58.6 49-92.5 8-28.3-1.6-57.8 0.9-86.4 0.6-5.8 1.6-11.6 3.4-17.4z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m904.3 718.2c0 4.9-4 9-9 9-5 0-9-4.1-9-9 0-5 4-9 9-9 5 0 9 4 9 9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m488.5 16.7c0 5-4 9-9 9-4.9 0-9-4-9-9 0-4.9 4.1-9 9-9 5 0 9 4.1 9 9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m163.4 801.2c0 4.9-4 9-9 9-5 0-9-4.1-9-9 0-5 4-9 9-9 5 0 9 4 9 9z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m729.5 839c0 3.9-3.2 7-7 7-3.9 0-7-3.1-7-7 0-3.9 3.1-7 7-7 3.8 0 7 3.1 7 7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m117.7 170c0 1.7-1.4 3-3 3-1.7 0-3-1.3-3-3 0-1.7 1.3-3 3-3 1.6 0 3 1.3 3 3z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m753.7 80.5c-1.2 5.8-7 9.6-12.8 8.3-5.8-1.2-9.6-7-8.3-12.8 1.2-5.8 7-9.6 12.8-8.3 5.9 1.2 9.6 7 8.3 12.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m176.1 30.8c-0.4 2.3-2.7 3.8-5 3.3-2.3-0.5-3.7-2.7-3.2-5 0.4-2.3 2.7-3.8 5-3.3 2.3 0.5 3.7 2.8 3.2 5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m851.7 13c-0.5 2-2.4 3.2-4.3 2.8-2-0.4-3.2-2.3-2.8-4.3 0.4-1.9 2.3-3.2 4.3-2.7 1.9 0.4 3.2 2.3 2.8 4.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m89.6 872.3c-0.5 1.9-2.4 3.2-4.3 2.8-2-0.5-3.2-2.4-2.8-4.3 0.4-2 2.3-3.2 4.3-2.8 1.9 0.4 3.2 2.3 2.8 4.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.7
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m362.3 350.2c-0.6 8.1-7.6 14.1-15.7 13.5l-15.9-1.2c-3 11.6-8.5 22.2-15.8 31.2l10.4 12.1c5.2 6.2 4.5 15.4-1.6 20.7-6.2 5.2-15.4 4.5-20.7-1.6l-10.4-12.1c-10 5.9-21.3 9.7-33.2 10.9l-1.3 15.9c-0.6 8.1-7.6 14.1-15.7 13.5-8-0.6-14.1-7.7-13.4-15.7l1.2-15.9c-11.7-3.1-22.3-8.5-31.3-15.9l-12.1 10.4c-6.1 5.3-15.4 4.6-20.6-1.5-5.3-6.2-4.6-15.4 1.5-20.7l12.2-10.4c-5.9-10-9.7-21.3-10.9-33.3l-16-1.2c-8-0.6-14.1-7.6-13.4-15.7 0.6-8 7.6-14.1 15.7-13.5l15.9 1.2c3-11.6 8.5-22.2 15.8-31.2l-10.4-12.1c-5.2-6.1-4.5-15.4 1.6-20.6 6.1-5.3 15.4-4.6 20.6 1.5l10.4 12.1c10-5.8 21.3-9.6 33.3-10.9l1.2-15.9c0.6-8 7.7-14.1 15.7-13.5 8.1 0.7 14.1 7.7 13.5 15.8l-1.2 15.9c11.7 3 22.3 8.5 31.2 15.8l12.2-10.4c6.1-5.3 15.3-4.6 20.6 1.6 5.3 6.1 4.6 15.4-1.6 20.6l-12.1 10.4c5.9 10 9.7 21.3 10.9 33.3l15.9 1.2c8.1 0.6 14.1 7.7 13.5 15.7zm-51.9-3.9c2.5-32.9-22.1-61.5-54.9-64.1-32.9-2.5-61.5 22.1-64 55-2.5 32.8 22.1 61.5 54.9 64 32.8 2.5 61.5-22.1 64-54.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m688.9 783.3c-1.9 0-3.8-0.4-5.6-1.3-2.9-1.5-5-4.1-6-7.2l-2.9-9c-7.4 0.7-14.7 0.1-21.9-1.9l-4.3 8.4c-3.1 6-10.5 8.3-16.5 5.2-2.9-1.5-5-4-6-7.1-1-3.1-0.7-6.4 0.8-9.3l4.4-8.4c-5.8-4.7-10.5-10.4-14.1-16.8l-9.1 2.8c-6.4 2-13.3-1.5-15.3-7.9-1-3.1-0.7-6.4 0.8-9.3 1.5-2.9 4.1-5.1 7.2-6l9-2.9c-0.8-7.4-0.1-14.7 1.9-21.9l-8.4-4.3c-2.9-1.5-5.1-4.1-6-7.2-1-3.1-0.7-6.4 0.8-9.3 1.5-2.9 4-5 7.1-6 3.1-1 6.4-0.7 9.3 0.8l8.4 4.4c4.7-5.8 10.3-10.5 16.8-14.2l-2.8-9c-2.1-6.4 1.5-13.3 7.9-15.3 3.1-1 6.4-0.7 9.3 0.8 2.9 1.5 5 4 6 7.1l2.9 9.1c7.4-0.8 14.7-0.2 21.9 1.8l4.3-8.4c3.1-5.9 10.5-8.3 16.5-5.2 5.9 3.1 8.3 10.5 5.2 16.5l-4.4 8.4c5.8 4.7 10.5 10.3 14.1 16.8l9.1-2.9c3.1-0.9 6.4-0.7 9.3 0.8 2.9 1.5 5 4.1 6 7.2 2 6.4-1.6 13.3-8 15.3l-9 2.9c0.8 7.3 0.1 14.7-1.9 21.8l8.4 4.4c6 3.1 8.3 10.5 5.2 16.4-1.5 2.9-4 5.1-7.1 6-3.1 1-6.4 0.7-9.3-0.8l-8.4-4.3c-4.7 5.7-10.3 10.5-16.8 14.1l2.8 9c1 3.2 0.7 6.5-0.8 9.3-1.5 2.9-4 5.1-7.1 6.1q-1.8 0.5-3.7 0.5zm-11.7-21.9l3.9 12.2c0.7 2.1 2.1 3.8 4 4.8 2 1 4.2 1.2 6.3 0.5 2.1-0.6 3.8-2.1 4.8-4 1-1.9 1.2-4.2 0.5-6.2l-3.8-12.2 1.4-0.8c7.1-3.7 13.2-8.8 18.1-15.2l1-1.3 11.3 5.9c2 1 4.2 1.2 6.3 0.5 2.1-0.6 3.8-2.1 4.8-4 2.1-4 0.5-9-3.5-11.1l-11.4-5.9 0.5-1.5c2.4-7.7 3.1-15.6 2-23.5l-0.2-1.7 12.2-3.8c4.3-1.4 6.7-6 5.4-10.3-0.7-2.1-2.1-3.8-4.1-4.8-1.9-1-4.1-1.2-6.2-0.6l-12.2 3.9-0.8-1.5c-3.7-7-8.8-13.1-15.1-18l-1.4-1 5.9-11.4c2.1-4 0.5-8.9-3.5-11-4-2.1-9-0.5-11 3.5l-5.9 11.3-1.6-0.5c-7.7-2.3-15.5-3-23.5-2l-1.6 0.2-3.9-12.2c-0.7-2-2.1-3.8-4-4.8-2-1-4.2-1.2-6.3-0.5-4.3 1.4-6.7 6-5.3 10.3l3.8 12.2-1.4 0.8c-7.1 3.7-13.2 8.8-18.1 15.1l-1 1.3-11.3-5.8c-2-1.1-4.2-1.2-6.3-0.6-2.1 0.7-3.8 2.1-4.8 4.1-1 1.9-1.2 4.1-0.5 6.2 0.6 2.1 2.1 3.8 4 4.8l11.4 5.9-0.5 1.6c-2.4 7.6-3.1 15.5-2.1 23.4l0.3 1.7-12.2 3.9c-2.1 0.6-3.8 2.1-4.8 4-1 2-1.2 4.2-0.6 6.3 1.4 4.3 6 6.7 10.3 5.3l12.2-3.9 0.8 1.5c3.7 7.1 8.8 13.2 15.1 18l1.4 1.1-5.9 11.3c-1 2-1.2 4.2-0.6 6.3 0.7 2 2.1 3.8 4.1 4.8 4 2 8.9 0.5 11-3.5l5.9-11.4 1.6 0.5c7.7 2.4 15.5 3 23.5 2zm-8.8-11.1c-6.9 0-13.7-1.7-20-5-10.3-5.3-18-14.4-21.5-25.5-3.5-11.1-2.5-22.8 2.9-33.2 5.3-10.3 14.4-17.9 25.5-21.4 11.1-3.5 22.9-2.5 33.2 2.8 10.3 5.4 17.9 14.5 21.5 25.5 3.5 11.1 2.4 22.9-2.9 33.3-5.4 10.3-14.4 17.9-25.5 21.4-4.3 1.4-8.8 2.1-13.2 2.1zm0.1-83.2c-4 0-8.1 0.6-12 1.9-10.1 3.2-18.3 10.1-23.2 19.5-4.8 9.3-5.8 20.1-2.6 30.1 3.2 10.1 10.1 18.3 19.5 23.2 9.4 4.9 20.1 5.8 30.2 2.6 10-3.2 18.3-10.1 23.1-19.5 4.9-9.4 5.8-20.1 2.6-30.1-3.1-10.1-10.1-18.3-19.4-23.2-5.8-3-12-4.5-18.2-4.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m793.9 708.7q-1.1 0-2.2-0.2c-8.6-1.2-14.6-9.2-13.3-17.8l1.9-13.1c-9.7-3.5-18.5-8.7-26.1-15.6l-10.7 8c-3.3 2.5-7.5 3.5-11.6 2.9-4.2-0.6-7.8-2.8-10.3-6.1-5.2-7-3.8-16.8 3.2-22l10.6-7.9c-4.4-9.3-6.9-19.2-7.5-29.5l-13.1-1.9c-8.6-1.2-14.5-9.2-13.3-17.8 0.6-4.1 2.8-7.8 6.2-10.3 3.3-2.5 7.5-3.6 11.6-3l13.2 1.9c3.4-9.6 8.6-18.4 15.5-26l-8-10.7c-2.5-3.4-3.5-7.5-2.9-11.6 0.6-4.2 2.8-7.9 6.1-10.4 3.4-2.5 7.5-3.5 11.7-2.9 4.1 0.6 7.8 2.8 10.3 6.1l8 10.7c9.2-4.4 19.1-6.9 29.4-7.5l1.9-13.1c1.2-8.6 9.2-14.6 17.8-13.3 4.1 0.6 7.8 2.8 10.3 6.1 2.5 3.4 3.6 7.5 3 11.7l-1.9 13.1c9.6 3.5 18.4 8.7 26.1 15.6l10.6-8c6.9-5.2 16.8-3.7 22 3.2 5.2 6.9 3.7 16.8-3.2 22l-10.7 7.9c4.4 9.3 6.9 19.2 7.5 29.4l13.2 2c8.5 1.2 14.5 9.2 13.2 17.8-1.2 8.5-9.2 14.5-17.8 13.2l-13.1-1.9c-3.5 9.7-8.7 18.5-15.5 26.1l7.9 10.7c5.2 6.9 3.8 16.8-3.2 22-3.3 2.5-7.5 3.5-11.6 2.9-4.2-0.6-7.9-2.8-10.4-6.1l-7.9-10.7c-9.3 4.4-19.2 6.9-29.4 7.5l-1.9 13.1c-1.2 7.8-7.9 13.5-15.6 13.5zm-39.4-51.9l1.2 1.2c7.9 7.4 17.1 12.9 27.4 16.3l1.6 0.5-2.4 16.5c-0.9 6.4 3.5 12.3 9.9 13.3 6.4 0.9 12.4-3.6 13.3-10l2.4-16.4 1.7-0.1c10.8-0.3 21.2-3 30.9-7.8l1.5-0.8 9.9 13.4c1.9 2.5 4.6 4.1 7.7 4.5 3.1 0.5 6.2-0.3 8.7-2.2 5.2-3.8 6.3-11.2 2.4-16.3l-9.9-13.4 1.1-1.2c7.4-7.9 12.9-17.1 16.3-27.4l0.6-1.6 16.4 2.4c6.4 0.9 12.4-3.5 13.3-9.9 0.9-6.4-3.5-12.4-9.9-13.3l-16.5-2.4v-1.6c-0.4-10.9-3-21.3-7.9-31l-0.7-1.5 13.3-9.9c5.2-3.9 6.2-11.2 2.4-16.4-1.9-2.5-4.6-4.1-7.7-4.6-3.1-0.4-6.2 0.3-8.7 2.2l-13.3 9.9-1.2-1.1c-8-7.4-17.2-12.9-27.5-16.3l-1.6-0.6 2.4-16.4c0.5-3.1-0.3-6.2-2.2-8.7-1.9-2.5-4.6-4.1-7.7-4.6-6.4-0.9-12.3 3.5-13.3 9.9l-2.3 16.5h-1.7c-10.9 0.4-21.3 3-31 7.9l-1.5 0.7-9.9-13.3c-1.9-2.5-4.6-4.1-7.7-4.6-3.1-0.4-6.2 0.4-8.7 2.2-2.5 1.9-4.1 4.6-4.6 7.7-0.4 3.1 0.4 6.2 2.2 8.7l10 13.3-1.2 1.3c-7.4 7.9-12.9 17.1-16.3 27.4l-0.5 1.6-16.5-2.4c-3.1-0.5-6.1 0.3-8.7 2.2-2.5 1.9-4.1 4.6-4.5 7.7-1 6.4 3.5 12.3 9.9 13.3l16.4 2.4 0.1 1.6c0.3 10.9 3 21.3 7.8 31l0.8 1.5-13.4 9.9c-2.5 1.9-4.1 4.6-4.5 7.7-0.5 3.1 0.3 6.2 2.2 8.7 1.8 2.5 4.6 4.1 7.7 4.6 3.1 0.4 6.1-0.4 8.7-2.2zm52.5 4c-17.6 0-35.1-8-46.4-23.2-19.1-25.6-13.8-61.9 11.8-81 12.3-9.2 27.6-13.1 42.9-10.9 15.3 2.3 28.8 10.3 38 22.7 9.2 12.4 13.1 27.6 10.9 42.9-2.2 15.3-10.3 28.8-22.7 38-10.3 7.8-22.4 11.5-34.5 11.5zm-0.2-111.7c-11.5 0-22.6 3.7-32 10.7-23.8 17.8-28.7 51.6-11 75.4 17.8 23.8 51.6 28.7 75.4 10.9 11.5-8.6 19-21.2 21-35.4 2.1-14.2-1.5-28.4-10.1-39.9-8.6-11.6-21.2-19-35.4-21.1q-3.9-0.6-7.9-0.6zm33.6 98.6z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.8
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m535.3 716.7h-41.1c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h41.1c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m535.3 759.4h-41.1c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h41.1c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m566.3 802.6h-253.7c-3 0-5.4-2.5-5.4-5.5v-131.7c0-2.9 2.4-5.4 5.4-5.4h253.7c3 0 5.5 2.5 5.5 5.4v131.7c0 3-2.5 5.5-5.5 5.5zm-253.7-138.6c-0.8 0-1.4 0.7-1.4 1.4v131.7c0 0.8 0.6 1.5 1.4 1.5h253.7c0.8 0 1.5-0.7 1.5-1.5v-131.7c0-0.7-0.7-1.4-1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m566.3 802.6h-253.7c-3 0-5.4-2.5-5.4-5.5v-131.7c0-2.9 2.4-5.4 5.4-5.4h253.7c3 0 5.5 2.5 5.5 5.4v131.7c0 3-2.5 5.5-5.5 5.5zm-253.7-138.6c-0.8 0-1.4 0.7-1.4 1.4v131.7c0 0.8 0.6 1.5 1.4 1.5h253.7c0.8 0 1.5-0.7 1.5-1.5v-131.7c0-0.7-0.7-1.4-1.5-1.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m535.3 696h-195.8c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h195.8c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m535.3 737.5h-195.8c-1.1 0-2-0.9-2-2 0-1.2 0.9-2 2-2h195.8c1.1 0 2 0.8 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m445.1 716.7h-105.6c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h105.6c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m445.1 759.4h-105.6c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h105.6c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m410.7 779.2h-71.2c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h71.2c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.8
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m142.2 588.7h-46.1c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h46.1c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m142.2 540.7h-46.1c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h46.1c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m346.8 647.9h-286c-3 0-5.4-2.4-5.4-5.4v-148.9c0-3 2.4-5.4 5.4-5.4h286c3 0 5.4 2.4 5.4 5.4v148.9c0 3-2.4 5.4-5.4 5.4zm-286-155.7c-0.8 0-1.4 0.6-1.4 1.4v148.9c0 0.8 0.6 1.4 1.4 1.4h286c0.8 0 1.4-0.6 1.4-1.4v-148.9c0-0.8-0.6-1.4-1.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m346.8 647.9h-286c-3 0-5.4-2.4-5.4-5.4v-148.9c0-3 2.4-5.4 5.4-5.4h286c3 0 5.4 2.4 5.4 5.4v148.9c0 3-2.4 5.4-5.4 5.4zm-286-155.7c-0.8 0-1.4 0.6-1.4 1.4v148.9c0 0.8 0.6 1.4 1.4 1.4h286c0.8 0 1.4-0.6 1.4-1.4v-148.9c0-0.8-0.6-1.4-1.4-1.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m316.1 612h-220c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h220c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m316.1 565.4h-220c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h220c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m316.1 588.7h-118.6c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h118.6c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m316.1 540.7h-118.6c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h118.6c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m316.1 518.4h-80c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h80c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m680 728.7l-218.9-129.7c-1.7-1.1-2.3-3.3-1.3-5.1l176.7-298c1-1.7 3.3-2.3 5.1-1.2l218.8 129.7c1.8 1 2.3 3.3 1.3 5.1l-176.7 297.9c-1 1.8-3.3 2.4-5 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m674.3 716.8l-218.9-129.8c-1.7-1-2.3-3.3-1.2-5l176.6-298c1.1-1.7 3.3-2.3 5.1-1.3l218.8 129.8c1.8 1 2.4 3.3 1.3 5l-176.6 298c-1.1 1.8-3.4 2.3-5.1 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m737.1 713.1l-250.1-46.1c-2.1-0.3-3.4-2.3-3-4.3l62.8-340.6c0.3-2.1 2.3-3.4 4.3-3l250.2 46.1c2 0.4 3.3 2.3 3 4.3l-62.8 340.7c-0.4 2-2.3 3.3-4.4 2.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m735.4 704.2l-257.4-47.4 64.1-348 257.5 47.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m731.8 703.6l-250.2-46.2c-2-0.3-3.3-2.3-3-4.3l62.8-340.6c0.4-2 2.3-3.4 4.3-3l250.2 46.1c2 0.4 3.4 2.3 3 4.3l-62.8 340.7c-0.4 2-2.3 3.3-4.3 3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m760.6 397.3q-0.2 0-0.4-0.1l-62.6-11.5c-1.1-0.2-1.8-1.2-1.6-2.3 0.2-1.1 1.2-1.8 2.3-1.6l62.7 11.5c1.1 0.2 1.8 1.3 1.6 2.3-0.2 1-1 1.7-2 1.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m756.9 417.3q-0.2 0-0.3 0l-62.7-11.6c-1.1-0.2-1.8-1.2-1.6-2.3 0.2-1.1 1.3-1.8 2.4-1.6l62.6 11.5c1.1 0.2 1.8 1.3 1.6 2.3-0.2 1-1 1.7-2 1.7z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m752.9 439q-0.2 0-0.3 0l-62.7-11.5c-1.1-0.2-1.8-1.3-1.6-2.4 0.2-1.1 1.2-1.8 2.4-1.6l62.6 11.6c1.1 0.2 1.8 1.2 1.6 2.3-0.2 1-1 1.6-2 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m656 457.5l-107.3-19.8c-2.2-0.4-3.6-2.4-3.2-4.6l21.3-115.4c0.4-2.2 2.5-3.6 4.6-3.2l107.3 19.7c2.2 0.4 3.7 2.5 3.3 4.7l-21.3 115.4c-0.4 2.2-2.5 3.6-4.7 3.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m652.1 450.8l-102.3-18.8c-2.2-0.4-3.6-2.5-3.2-4.7l20.1-109.3c0.4-2.1 2.5-3.6 4.7-3.2l102.3 18.9c2.1 0.4 3.6 2.5 3.2 4.7l-20.2 109.2c-0.4 2.2-2.4 3.6-4.6 3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m675 348.7l-110.2-20.3 1.9-10.5c0.4-2.1 2.4-3.5 4.6-3.1l102.6 18.9c2.1 0.4 3.4 2.4 3 4.4z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m595.6 382.7q-1.1 0-2.3-0.2l-1.5-0.3c-8.1-1.5-13.5-9.3-12-17.4l3.8-20.9c0.3-1.6 1.9-2.7 3.5-2.4 1.6 0.3 2.7 1.9 2.4 3.5l-3.8 20.9c-0.9 4.8 2.3 9.5 7.1 10.4l1.6 0.3c3.7 0.7 7.4-1.8 8.1-5.6l9.7-52.8c0.7-3.9-1.9-7.7-5.8-8.4l-2.6-0.5c-4.1-0.7-8.1 2-8.8 6.1l-0.3 1.3c-0.3 1.7-1.9 2.7-3.5 2.4-1.6-0.3-2.7-1.8-2.4-3.5l0.3-1.3c1.3-7.3 8.4-12.2 15.8-10.9l2.6 0.5c7.2 1.3 11.9 8.2 10.6 15.3l-9.7 52.9c-1.2 6.2-6.6 10.6-12.8 10.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m606 338.3q0 0-0.1 0l-40-7.4c-0.6-0.1-0.9-0.6-0.8-1.1 0.1-0.6 0.6-0.9 1.1-0.8l40 7.3c0.6 0.1 0.9 0.7 0.8 1.2-0.1 0.5-0.5 0.8-1 0.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m728.3 545q-0.2 0-0.4 0l-191.3-35.3c-1.1-0.2-1.8-1.3-1.6-2.3 0.2-1.1 1.2-1.9 2.3-1.7l191.4 35.3c1 0.2 1.8 1.3 1.6 2.4-0.2 0.9-1.1 1.6-2 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m714.6 619.2q-0.2 0-0.4 0l-191.3-35.3c-1.1-0.2-1.8-1.2-1.6-2.3 0.2-1.1 1.2-1.8 2.3-1.6l191.4 35.3c1.1 0.1 1.8 1.2 1.6 2.3-0.2 0.9-1 1.6-2 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m620.5 563.5q-0.1 0-0.3 0l-90.5-16.7c-1.1-0.2-1.8-1.2-1.6-2.3 0.2-1.1 1.2-1.8 2.3-1.6l90.5 16.6c1.1 0.2 1.8 1.3 1.6 2.4-0.2 0.9-1 1.6-2 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m633 495.9q-0.2 0-0.4-0.1l-90.4-16.6c-1.1-0.2-1.8-1.3-1.6-2.4 0.2-1 1.2-1.8 2.3-1.6l90.5 16.7c1.1 0.2 1.8 1.3 1.6 2.3-0.2 1-1 1.7-2 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m721.5 581.8q-0.2 0-0.4 0l-86.2-15.9c-1-0.2-1.8-1.2-1.6-2.3 0.2-1.1 1.3-1.8 2.4-1.6l86.2 15.8c1 0.2 1.8 1.3 1.6 2.4-0.2 0.9-1.1 1.6-2 1.6z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m701.2 188.7h-106.3c-3.7 0-6.7-3-6.7-6.7v-35.5c0-3.7 3-6.7 6.7-6.7h106.3c3.7 0 6.7 3 6.7 6.7v35.5c0 3.7-3 6.7-6.7 6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m781.4 242h-148.8c-3.7 0-6.7-3-6.7-6.7v-52.9c0-3.6 3-6.6 6.7-6.6h148.8c3.6 0 6.6 3 6.6 6.6v52.9c0 3.7-3 6.7-6.6 6.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m665.5 228h164.8c5 0 9 4.1 9 9.1v50.4c0 5-4 9.1-9 9.1h-164.8c-4.9 0-9-4.1-9-9.1v-50.4c0-5 4.1-9.1 9-9.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m665.5 228h164.8c5 0 9 4.1 9 9.1v50.4c0 5-4 9.1-9 9.1h-164.8c-4.9 0-9-4.1-9-9.1v-50.4c0-5 4.1-9.1 9-9.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m781.3 270.3c-4.4 0-8-3.5-8-7.9 0-4.4 3.6-8 8-8 4.4 0 7.9 3.6 7.9 8 0 4.4-3.5 7.9-7.9 7.9zm0-13.9c-3.3 0-6 2.7-6 6 0 3.3 2.7 5.9 6 5.9 3.3 0 5.9-2.6 5.9-5.9 0-3.3-2.6-6-5.9-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m748.5 270.3c-4.4 0-7.9-3.5-7.9-7.9 0-4.4 3.5-8 7.9-8 4.4 0 8 3.6 8 8 0 4.4-3.6 7.9-8 7.9zm0-13.9c-3.3 0-5.9 2.7-5.9 6 0 3.3 2.6 5.9 5.9 5.9 3.3 0 6-2.6 6-5.9 0-3.3-2.7-6-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m718 270.3c-4.4 0-8-3.5-8-7.9 0-4.4 3.6-8 8-8 4.4 0 7.9 3.6 7.9 8 0 4.4-3.5 7.9-7.9 7.9zm0-13.9c-3.3 0-6 2.7-6 6 0 3.3 2.7 5.9 6 5.9 3.2 0 5.9-2.6 5.9-5.9 0-3.3-2.7-6-5.9-6z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m264.8 144.6h255.2c5.2 0 9.3 4.2 9.3 9.3v376c0 17.7-14.3 32.1-32.1 32.1h-177.2c-37.8 0-68.5-30.6-68.5-68.4v-335.8c0-7.3 6-13.2 13.3-13.2z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m254.8 144.6h269.6c2.7 0 4.9 2.2 4.9 5v381.8c0 16.9-13.7 30.6-30.6 30.6h-184.8c-34.4 0-62.4-27.9-62.4-62.3v-351.9c0-1.8 1.5-3.2 3.3-3.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m278.4 144.6h247c2.2 0 3.9 1.8 3.9 3.9v383.9c0 16.4-13.2 29.6-29.5 29.6h-162.3c-33.8 0-61.3-27.4-61.3-61.3v-353.9c0-1.2 1-2.2 2.2-2.2z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m359 515.5v-17.6h225.6v17.6c0 25.7-20.8 46.5-46.5 46.5h-223.1c24.5-1.4 44-21.6 44-46.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m383.7 515.5v-17.6h200.9v17.6c0 25.7-18.5 46.5-41.4 46.5h-198.6c21.8-1.4 39.1-21.6 39.1-46.5z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m487.2 449.7h-160.5c-1.1 0-2-0.8-2-2 0-1.1 0.9-2 2-2h160.5c1.1 0 2 0.9 2 2 0 1.2-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m490.5 382.2h-166.8c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h166.8c1.2 0 2 0.9 2 2 0 1.1-0.8 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m407 415.9h-85.3c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h85.3c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m400.5 415.9h-72.3c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h72.3c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m434.7 310h-109.8c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h109.8c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m485.6 310h-33.4c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h33.4c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m490.5 343.7h-118.9c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h118.9c1.2 0 2 0.9 2 2 0 1.1-0.8 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m359.9 343.7h-36.2c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h36.2c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m487.2 281.4h-160.5c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h160.5c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m487.2 213.8h-160.5c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h160.5c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m385.6 247.6h-60.7c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h60.7c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m486 247.6h-72.4c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h72.4c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.2
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m738.8 391.8c0 69.9-56.7 126.6-126.6 126.6-69.9 0-126.6-56.7-126.6-126.6 0-69.9 56.7-126.6 126.6-126.6 69.9 0 126.6 56.7 126.6 126.6z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m513 400.9c-4.4 0-8-3.6-8-8 0-63.9 51.9-115.8 115.8-115.8 4.4 0 8 3.6 8 8 0 4.4-3.6 8-8 8-55 0-99.8 44.8-99.8 99.8 0 4.4-3.6 8-8 8z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m612.2 522.4c-72 0-130.6-58.6-130.6-130.6 0-72 58.6-130.6 130.6-130.6 72 0 130.6 58.6 130.6 130.6 0 72-58.6 130.6-130.6 130.6zm0-253.2c-67.6 0-122.6 55-122.6 122.6 0 67.6 55 122.6 122.6 122.6 67.6 0 122.6-55 122.6-122.6 0-67.6-55-122.6-122.6-122.6z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m719.2 491.9l-17.1 17.1c-24.9 19.1-56.1 30.5-89.9 30.5-81.6 0-147.7-66.1-147.7-147.7 0-81.6 66.1-147.7 147.7-147.7 81.6 0 147.7 66.1 147.7 147.7 0 34-11.5 65.2-30.8 90.2q-0.3 0.2-0.6 0.5zm19.7-100.1c0-69.9-56.7-126.6-126.6-126.6-69.9 0-126.6 56.7-126.6 126.6 0 69.9 56.7 126.6 126.6 126.6 69.9 0 126.6-56.7 126.6-126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m612.2 541.5c-82.6 0-149.7-67.2-149.7-149.7 0-82.6 67.1-149.7 149.7-149.7 82.5 0 149.7 67.1 149.7 149.7 0 33.4-10.8 65-31.2 91.4l-0.4 0.4c-0.1 0.1-0.3 0.2-0.3 0.3l-26.7 26.6c-26.4 20.3-57.9 31-91.1 31zm0-295.4c-80.4 0-145.7 65.3-145.7 145.7 0 80.3 65.3 145.7 145.7 145.7 32.3 0 62.9-10.4 88.5-30.1l26.4-26.3q0.3-0.3 0.6-0.5c19.8-25.7 30.2-56.4 30.2-88.8 0-80.4-65.4-145.7-145.7-145.7zm0 274.3c-70.9 0-128.6-57.7-128.6-128.6 0-70.9 57.7-128.6 128.6-128.6 70.9 0 128.6 57.7 128.6 128.6 0 70.9-57.7 128.6-128.6 128.6zm0-253.2c-68.7 0-124.6 55.9-124.6 124.6 0 68.7 55.9 124.6 124.6 124.6 68.7 0 124.6-55.9 124.6-124.6 0-68.7-55.9-124.6-124.6-124.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m708.7 524.2l-6.9-7c-2.2-2.2-2.2-5.8 0-8l0.3-0.2 17.1-17.1c-2.2 2.2-2.2 5.7 0 8l5.7 5.7c-7.2 7.2-13.9 14.7-16.2 18.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m728.5 482.5q0.3-0.3 0.6-0.5c2.3-1.7 5.4-1.5 7.4 0.5l6.7 6.6c-4.1 2.8-11.4 9.5-18.3 16.5l-5.7-5.7c-2.2-2.3-2.2-5.8 0-8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m728.5 482.5q0.3-0.3 0.6-0.5c2.3-1.7 5.4-1.5 7.4 0.5l6.7 6.6c-4.1 2.8-11.4 9.5-18.3 16.5l-5.7-5.7c-2.2-2.3-2.2-5.8 0-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m850.4 631.8c-10.6 10.7-27.8 10.7-38.3 0l-104.1-105.2c-0.3-0.3 0-1.2 0.7-2.4 2.3-3.9 9-11.4 16.2-18.6 6.9-7 14.2-13.7 18.3-16.5 1.6-1.1 2.8-1.6 3.1-1.2l104.1 105.2c10.5 10.7 10.5 28 0 38.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s6",
    d: "m850.4 631.8c-10.6 10.7-136.2-115.3-127.5-124.2 10.2-10.5 22-21.1 23.4-19.7l104.1 105.2c10.5 10.7 10.5 28 0 38.7z"
  })))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m466.2 462.5h-341.9c-20 0-36.2-16.2-36.2-36.2 0-19.9 16.2-36.1 36.2-36.1h341.9c20 0 36.2 16.2 36.2 36.1 0 20-16.2 36.2-36.2 36.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m466.2 462.5h-55.6l-0.2-72.3h55.8c20 0 36.2 16.2 36.2 36.1 0 20-16.2 36.2-36.2 36.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m452.2 439c-8.8 0-15.9-7.1-15.9-15.8 0-8.7 7.1-15.8 15.9-15.8 8.7 0 15.8 7.1 15.8 15.8 0 4.2-1.7 8.2-4.7 11.2-2.9 3-6.9 4.6-11.1 4.6zm0-27.6c-6.6 0-11.9 5.3-11.9 11.8 0 6.5 5.3 11.8 11.9 11.8 3.1 0 6.1-1.2 8.3-3.4 2.3-2.3 3.5-5.3 3.5-8.4 0-6.5-5.3-11.8-11.8-11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m474.4 447.6c-0.5 0-1-0.2-1.4-0.6l-12.5-12.6c-0.8-0.7-0.8-2 0-2.8 0.7-0.8 2-0.8 2.8 0l12.5 12.6c0.8 0.8 0.8 2 0 2.8-0.4 0.4-0.9 0.6-1.4 0.6z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m491.3 557.4v168.8c0 11.1-9.1 20.2-20.2 20.2h-293.5c-11.1 0-20.2-9.1-20.2-20.2v-104.6-64.2-55.9c0-11.9 9.7-21.6 21.7-21.6h78.6c12 0 21.6 9.7 21.6 21.6v14.2c0 11.9 9.7 21.5 21.6 21.5h170.2c11.1 0 20.2 9.1 20.2 20.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m472.5 557.4v168.8c0 11.1-9 20.2-20.1 20.2h-293.5c-11.2 0-20.2-9.1-20.2-20.2v-104.6-64.2-55.9c0-11.9 9.7-21.6 21.6-21.6h78.6c12 0 21.7 9.7 21.7 21.6v14.2c0 11.9 9.7 21.5 21.6 21.5h170.2c11.1 0 20.1 9.1 20.1 20.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m472.5 557.4v168.8c0 11.1-9 20.2-20.1 20.2h-293.5c-11.2 0-20.2-9.1-20.2-20.2v-104.6-64.2-55.9c0-11.9 9.7-21.6 21.6-21.6h78.6c12 0 21.7 9.7 21.7 21.6v14.2c0 11.9 9.7 21.5 21.6 21.5h170.2c11.1 0 20.1 9.1 20.1 20.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m426.6 557.4v168.8c0 11.1-7.8 20.2-17.4 20.2h-253.1c-9.6 0-17.4-9.1-17.4-20.2v-104.6-64.2-55.9c0-11.9 8.3-21.6 18.7-21.6h67.7c10.4 0 18.7 9.7 18.7 21.6v14.2c0 11.9 8.3 21.5 18.6 21.5h146.8c9.6 0 17.4 9.1 17.4 20.2z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m154.4 559.7c-1.1 0-2-0.9-2-2v-49.1c0-7.6 6.2-13.8 13.8-13.8h57.9c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2h-57.9c-5.4 0-9.8 4.4-9.8 9.8v49.1c0 1.1-0.9 2-2 2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.159b8d1b76d7bb7b8d29130612803098.svg";
export { ForwardRef as ReactComponent };